import { useState } from 'react';
import { getApiErrorMessage, postEmail } from '../services/emailApi';

const useSendCouponFeedback = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null)

    const sendCouponFeedback = async ({couponId, name, email, message } ) => {

        setLoading(true)
        setError(null)
        setResponse(null)

        try {
            const res = await postEmail('/feedback/coupon', { couponId, email, name, message });
            setResponse(res.data.message)

        } catch (err) {
            setError(getApiErrorMessage(err, 'Erro ao enviar feedback'));
        } finally {
            setLoading(false);
        }
    };
    return { sendCouponFeedback, response, loading, error };
}

export default useSendCouponFeedback
